if (!window.customElements.get('banner-media')) {

  class BannerMedia extends HTMLElement {
    constructor() {
      super();
      this.motion = null;
      this.isInitialized = false;
      this.playButton = null;
      this.desktopVideo = null;
      this.mobileVideo = null;
      this.currentVideo = null;
      this.isPlaying = false;
      this.autoplay = false;
      this.observer = null;
    }
  
    connectedCallback() {
      // Prevent multiple initializations
      if (this.isInitialized) return;
      
      // Wait for Motion.dev to be ready before initializing
      whenReady('motion', (motion) => {
        this.motion = motion;
        
        // Add a small delay to ensure everything is ready
        setTimeout(() => {
          if (!this.isInitialized) {
            this.init();
            this.isInitialized = true;
          }
        }, 100);
      });
    }
  
    init() {
      // Find the play button and videos
      this.playButton = this.querySelector('button');
      this.desktopVideo = this.querySelector('.banner-media__video-desktop');
      this.mobileVideo = this.querySelector('.banner-media__video-mobile');
      
      // Determine which video to use based on screen size
      this.setCurrentVideo();
      
      // Add event listeners
      if (this.playButton) {
        this.playButton.addEventListener('click', () => this.handlePlayClick());
      }
      
      // Listen for window resize to switch videos
      window.addEventListener('resize', () => {
        this.setCurrentVideo();
      });

      // Autoplay logic
      this.autoplay = this.dataset.autoplay === "true";
        if (this.autoplay && this.currentVideo) {
          this.setupAutoplayObserver();
        }
      }
      setupAutoplayObserver() {
        if (this.observer) {
          this.observer.disconnect();
        }
        this.observer = new window.IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              if (!this.isPlaying) {
                this.playVideo();
                if (this.playButton) {
                  this.playButton.style.display = 'none';
                }
              }
            } else {
              if (this.isPlaying) {
                this.pauseVideo();
              }
            }
          });
        }, {
          root: null,
          rootMargin: '0px',
          threshold: 0.5
        });
        if (this.currentVideo) {
          this.observer.observe(this.currentVideo);
        }
    }
  
    setCurrentVideo() {
      const isMobile = window.innerWidth <= 767;
      
      if (isMobile && this.mobileVideo) {
        this.currentVideo = this.mobileVideo;
      } else if (this.desktopVideo) {
        this.currentVideo = this.desktopVideo;
      } else {
        // Fallback to any video element if specific classes don't exist
        this.currentVideo = this.mobileVideo || this.desktopVideo || this.querySelector('video');
      }
      // Re-setup autoplay observer if needed
      if (this.autoplay && this.currentVideo) {
        this.setupAutoplayObserver();
      }
    }
  
    handlePlayClick() {
      if (!this.currentVideo) return;
      
      if (this.isPlaying) {
        this.pauseVideo();
      } else {
          this.playVideo();
          // Use GSAP for smooth button fade out
          if (this.motion && this.playButton) {
            if(this.closest(".inview-container") !== null) {
              this.motion.animate(this.closest(".inview-container"), {
                clipPath: "inset(0% round 30px)"
              }, {
                duration: 0.75,
                easing: [0.25, 0.46, 0.45, 0.94] // power2.out equivalent
              });
              if(this.querySelector("video")) {
                this.motion.animate(this.querySelector("video"), {
                  borderRadius: "30px"
                }, {
                  duration: 0.75,
                  easing: [0.25, 0.46, 0.45, 0.94] // power2.out equivalent
                });
              }
            }            
            this.motion.animate(this.playButton, {
              transition: "none"
            }, { duration: 0 });
            this.motion.animate(this.playButton, {
              opacity: 0
            }, {
              duration: 0.65,
              delay: .15,
              easing: [0.25, 0.46, 0.45, 0.94] // power2.out equivalent
            }).finished.then(() => {
              this.playButton.style.display = 'none';
            });
          } else {
            this.playButton.style.opacity = 0;
            this.playButton.style.visibility = 'hidden';
          }
      }
    }
  
    playVideo() {
      if (!this.currentVideo) return;
      
      // Add controls to the video
      this.currentVideo.controls = true;

      // Ensure video is muted for autoplay
      this.currentVideo.muted = true;
      
      // Play the video
      this.currentVideo.play().then(() => {
        this.isPlaying = true;
      //   this.updatePlayButton();
      }).catch(error => {
        console.error('Error playing video:', error);
      });
    }
  
    pauseVideo() {
      if (!this.currentVideo) return;
      
      this.currentVideo.pause();
      this.isPlaying = false;
      this.updatePlayButton();
    }
  
    updatePlayButton() {
      if (!this.playButton) return;
      
      // Use Motion.dev for smooth button fade in
      if (this.motion) {
        this.motion.animate(this.playButton, {
          opacity: 1,
          visibility: 'visible'
        }, {
          duration: 0.3,
          easing: [0.25, 0.46, 0.45, 0.94] // power2.out equivalent
        });
      } else {
        this.playButton.style.opacity = 1;
        this.playButton.style.visibility = 'visible';
      }
    }
  
    disconnectedCallback() {
      // Clean up event listeners if needed
      if (this.playButton) {
        this.playButton.removeEventListener('click', this.handlePlayClick);
      }
      window.removeEventListener('resize', this.setCurrentVideo);
      if (this.observer) {
        this.observer.disconnect();
      }
    }
  }
  
  // Register the web component
  customElements.define('banner-media', BannerMedia);

}